import { createSlice } from "@reduxjs/toolkit";
import {
  getToken,
  getUserData,
  isUserLogin,
  resetLoginData,
  setUserData,
  setUserLogin,
} from "../../utility/utils";

const initialState = {
  user: getUserData() || {},
  token: getToken(),
  loginStatus: isUserLogin() || false,
};

export const accountSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setLogin: (state, action) => {
      setUserLogin({ ...action.payload });
      state.user = action.payload.userData;
      state.loginStatus = true;
    },

    setUser: (state, action) => {
      if (!action.payload) return;
      state.user = { ...state.user, ...action.payload };
      state.loginStatus = true;
      setUserData({ ...state.user, ...action.payload });
    },

    resetLogin: (state) => {
      resetLoginData();
      state.user = {};
      state.loginStatus = false;
    },
  },
});

export const { setLogin, setUser, resetLogin } = accountSlice.actions;
export default accountSlice.reducer;
